import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getViewAllDetails = createApi(`ViewAllLineItemsDataSlice`,"GET");

const ViewAllLineItemsDataSlice = createSlice({
  name: 'ViewAllLineItemsDataSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getViewAllDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getViewAllDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getViewAllDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ViewAllLineItemsDataSlice.reducer;